// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b7db9644","598":"b2edf3d4","787":"a40a19f2"}[chunkId] + ".chunk.js";
};